import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-selector",
  templateUrl: "./icon-selector.component.html",
  styleUrls: ["./icon-selector.component.scss"]
})
export class IconSelectorComponent
{

  @Input() type: string;

  constructor() { }

}
